import React, { useEffect } from "react";
import ReactDOM from "react-dom";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  btnClose?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, btnClose=true}) => {
 /*
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);

  }, [onClose]);
*/
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-20 flex items-start justify-center bg-gray-800 bg-opacity-50 sub-compomente p-5" 
    >
      <div
        className="bg-white md:mt-20 relative shadow-lg n-menu-content-user rounded-lg animate-fadeIn "
        onClick={(e) => e.stopPropagation()} 
      >

        {
          btnClose&&(
            <button
              onClick={onClose}
              className="absolute top-3 right-4 text-gray-600 hover:text-gray-800 text-lg 
                       w-10 h-10 flex items-center justify-center rounded-full bg-white 
                       shadow-md hover:shadow-lg transition" 
            >
              ✖
            </button>
          )
        }
        <div className="max-h-[80vh] overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
    , document.body  
  );
};

export default Modal;
